<div class="price-range-container">
  @if (msrp) {
    <div class="strike-through">
      <span class="sr-only">{{ 'productList.variant.originalPrice' | cxTranslate }}: </span>
      <span class="price-range">
        {{ msrp }}
      </span>
    </div>
  }

  @if (price) {
    <div class="product-price">
      @if (msrp) {
        <span class="sr-only">{{ 'productList.variant.nowPrice' | cxTranslate }}: </span>
      }
      <span class="price-range" [ngClass]="{ 'with-strike': msrp }">
        {{ price }}
      </span>
    </div>
  }
</div>
